import { useSelector } from "react-redux";
import VideoCard from "../components/VideoCard";
import PageHeader from "../components/PageHeader";


const Videos = () => {

    const { videos, hasVideoSection } = useSelector((state) => state.auth);


  return (
    <>
     <PageHeader title={`videos`} />
     <div className="callouts-wrapper">
      <div className="container">
       

        <div  className="video-section">
          {videos.map((videos) => (
            <VideoCard
              videoUrl={videos.video_link}
              customThumbnail={`${
                videos.thumbnail_link === "#"
                  ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQykzoZeCE0p7LeuyHnLYCdPP2jju9d5PaMeA&s"
                  : videos.thumbnail_link
              }`}
            />
          ))}
        </div>
      </div>
    </div>
    </>
    
  );
};

export default Videos;
